<template>
  <v-app>
    <v-container fluid>
      <v-row no-gutters class="px-2 px-md-5">
        <v-col cols="12">
          <div class="mb-4 mb-md-8">
            <a href="about">
              <v-img 
                :src="images[0]" 
                class="banner-image"
                :height="$vuetify.display.smAndDown ? '200' : '400'"
                cover
              ></v-img>
            </a>
          </div>

          <h2>Latest Notices</h2>
          <br />

          <div class="mb-8 mb-md-12">
            <h1 class="mb-4">BorneoParkMiri Offstreet LPR System</h1>
            <v-row justify="center">
              <v-col cols="12" md="8" lg="6">
                <div class="video-container">
                  <iframe
                    width="100%"
                    :height="$vuetify.display.smAndDown ? '250' : '500'"
                    src="https://www.youtube.com/embed/R-Gn1AWzrtQ"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  ></iframe>
                </div>
              </v-col>
            </v-row>
          </div>
          <v-divider class="my-6 my-md-12"></v-divider>

          <div class="mb-8 mb-md-12">
            <h1 class="mb-4">BorneoParkBTU App</h1>
            <div class="text-center">
              <p class="mb-4 mx-auto" style="max-width: 600px;">
                Effortless Street Parking in Bintulu: Our mobile app ensures stress-free street parking with cashless payments and convenient seasonal parking for a seamless experience anytime, anywhere.
              </p>
            </div>
            <v-row justify="center">
              <v-col cols="12" md="8" lg="6">
                <div class="video-container">
                  <iframe
                    width="100%"
                    :height="$vuetify.display.smAndDown ? '250' : '500'"
                    src="https://www.youtube.com/embed/Hy1-QrAj9q0"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  ></iframe>
                </div>
              </v-col>
            </v-row>
          </div>
          <v-divider class="my-6 my-md-12"></v-divider>

          <div class="mb-8 mb-md-12">
            <h1 class="mb-4">BorneoParkMiri App</h1>
            <div class="text-center">
              <p class="mb-4 mx-auto" style="max-width: 600px;">
                Effortless Street Parking in Miri: Our mobile app ensures stress-free street parking with cashless payments, convenient seasonal parking and compound payment options for a seamless experience anytime, anywhere.
              </p>
            </div>
            <v-row justify="center">
              <v-col cols="12" md="8" lg="6">
                <div class="video-container">
                  <iframe
                    width="100%"
                    :height="$vuetify.display.smAndDown ? '250' : '500'"
                    src="https://www.youtube.com/embed/eZwrxEL-hR0"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  ></iframe>
                </div>
              </v-col>
            </v-row>
          </div>
          <v-divider class="my-6 my-md-12"></v-divider>

          <div class="mb-8 mb-md-12">
            <h1 class="mb-4">BPS/MPS Power Brand Award</h1>
            <v-row justify="center">
              <v-col cols="12" md="8" lg="6">
                <v-img src="@/assets/award.jpeg" class="mb-4" contain max-height="800"></v-img>
              </v-col>
            </v-row>
          </div>
          <v-divider class="my-6 my-md-12"></v-divider>

          <div class="mb-8 mb-md-12">
            <h1 class="mb-4">Smart Proof for parking summonses via phone photos</h1>
            <v-row justify="center">
              <v-col cols="12" md="8" lg="6">
                <v-img src="@/assets/smart-proof.jpeg" class="mb-4" contain max-height="1000"></v-img>
              </v-col>
            </v-row>
          </div>
          <v-divider class="my-6 my-md-12"></v-divider>

          <div class="mb-8 mb-md-12">
            <h1 class="mb-4">Online Payment For Your Convenience</h1>
            <div class="d-flex justify-center">
              <div style="max-width: 800px;">
                <p>
                  Miri motorists' can now purchase credits effective 26 March 2016 at all 14 BPS parking coupon booth to pay for their compounds online, 24/7 by downloading BPS mobile apps or using the web at online.borneoparking.com. Purchase of credits using credit cards and online banking are available through the web at online.borneoparking.com only. There will be a convenience charge of 3% by a third party payment gateway for those using credit card or online banking to purchase credits. <br><br>
                  Motorists can purchase credits as little as RM5.00, RM10.00 and so forth at all BPS parking booths and the system will generate a receipt with a 16 digits number. The motorist will then use the mobile apps or the web to register one time only with their email and a log-in password. After log in, motorists' go to the reload screen to reload the credits with the 16 digits provided in the receipt to start making payments online. For those using credit card or online banking, credits will be auto reloaded into their account. <br><br>
                  For more information please refer to Online Payment Guide.
                </p>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
export default {
  name: 'HomePage',
  data() {
    return {
      images: [
        require('@/assets/banner.jpeg')
      ]
    }
  }
};
</script>

<style scoped>
.banner-image {
  border-radius: 8px;
  overflow: hidden;
}

.video-container {
  border-radius: 8px;
  overflow: hidden;
}

@media (max-width: 600px) {
  .banner-image {
    border-radius: 4px;
  }
  
  .video-container {
    border-radius: 4px;
  }
}
</style>